module.exports = __webpack_public_path__ + "static/media/tooltip.4a846f3f.svg";